import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';


export default class ActionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      request: false
    };
    this.activate = this.activate.bind(this);
    this.toogleRequest = this.toogleRequest.bind(this);
  }

  static get propTypes() {
    return {
      isOpen: PropTypes.bool,
      action: PropTypes.func,
      onError: PropTypes.func,
      onSuccess: PropTypes.func,
      onCancel: PropTypes.func,
      message: PropTypes.string
    }
  }

  toogleRequest() {
    return this.setState(({ request }) => ({
      request: !request
    }));
  }

  activate() {
    const {
      onSuccess,
      onError,
      action
    } = this.props;
    this.toogleRequest();
    return action()
      .then(onSuccess)
      .catch(onError)
      .then(this.toogleRequest);
  }

  render() {
    const {
      isOpen,
      onCancel,
      message
    } = this.props;
    const { request } = this.state;
    return (
      <Modal
        isOpen={isOpen}
        onCancel={onCancel}
        onConfirm={this.activate}
        header='Confirm action'
        confirmButtonLoading={request}
        >
          {message}
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// src/components/shared/ActivationModal/index.jsx